import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect } from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { MdDelete } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { setMedicineDeleteIndex } from "./healthHistorySlice";
import FormCheckboxGroup from "../../components/formFields/FormCheckboxGroup";
import {
  requiredArrayValidator,
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
// import { GETALLACTIVEWITHFILTER_TYPE } from "../../_contstants/common";

const MedicineArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const MedicineDeleteIndex = useAppSelector(
    (state) => state.healthHistory.MedicineDeleteIndex
  );

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(setMedicineDeleteIndex(-1));
      dispatch(closeDialog());
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps?.onPush({
      value: {
        Name: "",
      },
    });
  }, [fieldArrayRenderProps]);

  useEffect(() => {
    pushElementInarray();
  }, []);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openDialog(`delete${fieldArrayRenderProps?.name}Dialog`));
    dispatch(setMedicineDeleteIndex(index));
  };

  return (
    <>
      {dialogName === `delete${fieldArrayRenderProps?.name}Dialog` && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Medicine Details"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(MedicineDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map(
          (MedicineDetails: any, index: number) => (
            <tr>
              <td>
                <Field
                  wrapperClassName="m-0"
                  name={`${fieldArrayRenderProps.name}.${index}.Name`}
                  placeholder="Medicine Name"
                  component={FormTextField}
                  validator={
                    fieldArrayRenderProps.formRenderProps.valueGetter(
                      `${fieldArrayRenderProps.name}.${index}.Dose`
                    )?.length > 0
                      ? requiredValidator
                      : skipValidator
                  }
                />
              </td>
              <td>
                <Field
                  id={`${fieldArrayRenderProps.name}.${index}.Dose`}
                  name={`${fieldArrayRenderProps.name}.${index}.Dose`}
                  marginRight={10}
                  marginBeetween={0}
                  component={FormCheckboxGroup}
                  options={[
                    { value: 1, label: "M" },
                    { value: 2, label: "A" },
                    { value: 3, label: "E" },
                  ]}
                  validator={
                    fieldArrayRenderProps.formRenderProps.valueGetter(
                      `${fieldArrayRenderProps.name}.${index}.Name`
                    )
                      ? requiredArrayValidator
                      : skipValidator
                  }
                  style={{ border: "1px solid gray" }}
                />
              </td>
              <td>
                {fieldArrayRenderProps.value.length - 1 === index ? (
                  <Button
                    style={{
                      height: 30,
                      width: 30,
                    }}
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={pushElementInarray}
                    type="button"
                  >
                    <FaPlus
                      className="absolute-position"
                      style={{ fontSize: "16px" }}
                    />
                  </Button>
                ) : (
                  <Button
                    style={{
                      height: 30,
                      width: 30,
                    }}
                    onClick={() => handleOpenDeleteDialog(index)}
                    fillMode={"solid"}
                    themeColor={"error"}
                    type="button"
                    size={"small"}
                  >
                    <MdDelete
                      className="absolute-position"
                      style={{ fontSize: "16px" }}
                    />
                  </Button>
                )}
              </td>
            </tr>
          )
        )}
    </>
  );
};

export default MedicineArray;
